import { UserInfoHeaderProps } from "./types";

import { useTranslation } from "react-i18next";

import BaseTag from "../Tags/BaseTag";
import BaseButton from "../Button/BaseButton";

import "./styles.css";

const UserInfoHeader = ({
  avatar,
  honorific,
  firstName,
  lastName,
  role,
  jobTitle,
  department,
  email,
  city,
  country,
  showLabels,
  primaryButtonLabel,
  secondaryButtonLabel,
  primaryButtonIcon,
  secondaryButtonIcon,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
}: UserInfoHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="user-info-header">
      <div className="user-info-header-container">
        {avatar}

        <div className="user-info-header-content">
          <div className="user-info-header-details-container">
            <div className="user-info-header-details">
              <span className="user-info-header-name-details header-l-medium">
                {honorific} {firstName} {lastName}
              </span>

              {role && <BaseTag label={role} hasRoundCorners />}
            </div>

            <div className="user-info-header-job-details header-s-regular">
              {(jobTitle || department) && (
                <>
                  {jobTitle} {jobTitle && department && showLabels && " - "}{" "}
                  {department}
                </>
              )}
            </div>
          </div>

          <div className="user-info-header-details-container">
            {email && (
              <div className="user-info-header-details body-m-regular">
                <>
                  {showLabels && (
                    <span className="body-m-medium">{t("labels.email")}:</span>
                  )}{" "}
                  {email}
                </>
              </div>
            )}

            <div className="user-info-header-details body-m-regular">
              <div className="user-info-header-residence-details">
                {showLabels && (city || country) && (
                  <span className="body-m-medium">
                    {t("profiles.placeOfResidence")}:
                  </span>
                )}
                {city} {country}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="user-info-header-buttons">
        {onSecondaryButtonClick && (
          <BaseButton
            variant="tertiary"
            leadingIcon={secondaryButtonIcon}
            onClick={onSecondaryButtonClick}
          >
            {secondaryButtonLabel}
          </BaseButton>
        )}

        {onPrimaryButtonClick && (
          <BaseButton
            variant="secondary"
            leadingIcon={primaryButtonIcon}
            onClick={onPrimaryButtonClick}
          >
            {primaryButtonLabel}
          </BaseButton>
        )}
      </div>
    </div>
  );
};

export default UserInfoHeader;
